// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 文档：https://v15.vuetifyjs.com/zh-Hans/getting-started/quick-start
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import '@mdi/font/css/materialdesignicons.css'
import store from './store'
import { create_wsConfig } from '../static/js/utils/utils'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import {
	setClientId,
	getClientId,
	getLangList,
	setLang,
	getLang,
	upload,
	hideStr,
	post,
	get,
	baseURL,
	jump,
	setAccount,
	getAccount,
	setToken,
	getToken,
	removeToken,
	setUid,
	getUid,
	removeUid,
	zmath,
	klineStyle
} from './plugins/utils.js'

// 国际化
const i18n = new VueI18n({
    locale: getLang(),  // 语言标识
    messages: {
        'zh': require('./plugins/lang/zh-cn'),
        'en': require('./plugins/lang/en-us')
    }
})

Vue.use(Vuetify, {
 theme: {
    primary: colors.red.darken1, // #E53935
    secondary: colors.red.lighten4, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
})

Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.setClientId = setClientId
Vue.prototype.getClientId = getClientId
Vue.prototype.upload = upload
Vue.prototype.hideStr = hideStr
Vue.prototype.post = post
Vue.prototype.get = get
Vue.prototype.baseURL = baseURL
Vue.prototype.jump = jump
Vue.prototype.setLang = setLang
Vue.prototype.getLang = getLang
Vue.prototype.getLangList = getLangList
Vue.prototype.setAccount = setAccount
Vue.prototype.getAccount = getAccount
Vue.prototype.setToken = setToken
Vue.prototype.getToken = getToken
Vue.prototype.removeToken = removeToken
Vue.prototype.setUid = setUid
Vue.prototype.getUid = getUid
Vue.prototype.removeUid = removeUid
Vue.prototype.zmath = zmath
Vue.prototype.amount_before = ''
Vue.prototype.amount_after = ''
Vue.prototype.windowHeight = document.documentElement.clientHeight
// 币种
Vue.prototype.amount_text = ''
// 长连接配置
Vue.prototype.$create_wsConfig = create_wsConfig
// k线样式
Vue.prototype.kStyle = klineStyle(1)

//判断是否登录
router.beforeEach((to, from, next) => {
	// console.log(to.name)
	if (localStorage.zWap && JSON.parse(localStorage.zWap).token) {
		next();
	}
	else {
		var free = [
			'index',
			'market',
			'home',
			'noticeDetail',
			'login',
			'findPassWord',
			'messageLogin',
			'emailLogin',
			'register',
			'agreement'
		];
		if (free.indexOf(to.name)>-1) {
			next();
		}
		else {
			router.push({ name: 'login' })
		}
	}
})

/* eslint-disable no-new */
new Vue({
	router,
	store,
	Vuetify,
	i18n,
	render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js